var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "component-container" }, [
    _c("div", { staticClass: "row" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 text-end mt-4" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn btn-primary",
              attrs: { to: "/facebook/reports/create" },
            },
            [
              _c("font-awesome-icon", { attrs: { icon: ["fas", "file"] } }),
              _c("span", { staticClass: "m-2" }, [
                _vm._v("Request a new Report"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-1" }, [
      _c("div", { staticClass: "col-sm-10" }, [
        _c("span", { staticClass: "mb-" }, [
          _vm._v("Current Folder: " + _vm._s(_vm.currentFolderName)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-2 text-end" }, [
        _c(
          "button",
          {
            class:
              _vm.currentFolderName != "/"
                ? "btn btn-outline-secondary"
                : "btn btn-outline-secondary disabled",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.goUpFolderLevel()
              },
            },
          },
          [
            _c("font-awesome-icon", { attrs: { icon: ["fas", "folder"] } }),
            _c("font-awesome-icon", {
              staticClass: "ms-1",
              attrs: { icon: ["fas", "up-long"] },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.isLoading
      ? _c("div", { staticClass: "text-center mt-3" }, [
          _c("h1", { staticClass: "display-6" }, [_vm._v("Loading...")]),
          _vm._v(" "),
          _c("span", {
            staticClass: "spinner-border spinner-border-sm",
            attrs: { role: "status", "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "visually-hidden" }, [
            _vm._v("Loading..."),
          ]),
        ])
      : _c(
          "div",
          { staticClass: "list-group" },
          [
            _vm._l(_vm.contents.folders, function (folder) {
              return _c(
                "a",
                {
                  key: folder.name,
                  staticClass: "list-group-item list-group-item-action",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      return _vm.clickFolder(folder.name)
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: ["far", "folder"] },
                  }),
                  _c("span", { staticClass: "ms-2" }, [
                    _vm._v(_vm._s(folder.name)),
                  ]),
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.contents.fileInfos, function (file) {
              return _c(
                "a",
                {
                  key: file.name,
                  staticClass: "list-group-item list-group-item-action",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      return _vm.clickFile(file.path, file.name)
                    },
                  },
                },
                [
                  _c("font-awesome-icon", { attrs: { icon: ["far", "file"] } }),
                  _c("span", { staticClass: "ms-3" }, [
                    _vm._v(_vm._s(file.name)),
                  ]),
                ],
                1
              )
            }),
          ],
          2
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-sm-6" }, [
      _c("h1", { staticClass: "display-6 mt-4 mb-3" }, [
        _vm._v("Existing Reports"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }